import { getDecodedTokenDetails } from "../Token/TokenService";

export const canAccessClientManagement = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    return decoded.permissions.some((p: string) =>
    ( (p === "Permissions.OrganizationManagment.View" ) ||
      (p === "Permissions.WorkingPointManagment.View" ) || 
      (p === "Permissions.WorkingPointManagment.View" ) ||
      (p === "Permissions.ArticleDiscounts.View")
    ));
};

export const canAccessArticleDiscountsManagmentButton = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    const hasArticleDiscountsView = decoded.permissions.includes("Permissions.ArticleDiscounts.View");
    const hasOrgMgmtCreate = decoded.permissions.includes("Permissions.OrganizationManagment.Create");

    return hasArticleDiscountsView && hasOrgMgmtCreate;
};

export const canAccessWorkingPointManagmentButton = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    return decoded.permissions.some((p: string) =>
        (p === "Permissions.WorkingPointManagment.Edit")
    );
};
export const canAccessOrganizationManagmentButton = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    return decoded.permissions.some((p: string) =>
        (p === "Permissions.OrganizationManagment.Edit")
    );
};
export const canAccessValidationPreordersButton = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    return decoded.permissions.some((p: string) =>
        (p === "Permissions.PreOrders.Edit")
    );
};

export const canAccessChangePasswordButton = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    return decoded.permissions.some((p: string) =>
        (p === "Permissions.PasswordReset.Edit")
    );
};

export const canAccessModifyUserPage = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    return decoded.permissions.some((p: string) =>
        (p === "Permissions.Clients.Edit")
    );
};

export const canAccessAddUserPage = async (): Promise<boolean> => {
    const decoded = await getDecodedTokenDetails();
    if (!decoded) return false;

    return decoded.permissions.some((p: string) =>
        (p === "Permissions.Clients.Create")
    );
};


